import { LoginEventPayload, OiamEvents, SendTokenPayload, SetConfigEventPayload } from '@oiambk/oiam-oauth-types';
import log from 'loglevel';
import { LogoutEventPayload } from '../model/constants';
import { StateService } from './state-service';

/**
 * Class gets external events from the EventQueue and dispatches it to the correct handler method
 */
export class EventActionDispatcher {
  private readonly stateService: StateService;

  constructor() {
    this.stateService = new StateService();
  }

  async dispatchEvent(
    name: string,
    payload: SetConfigEventPayload | LoginEventPayload | SendTokenPayload | LogoutEventPayload | undefined,
  ) {
    log.debug('oiam-oauth-wc: handle received event', name, payload || '');
    switch (name) {
      case OiamEvents.SETCONFIG: {
        await this.stateService.handleSetConfigEvent(payload as SetConfigEventPayload);
        break;
      }
      case OiamEvents.DOLOGIN: {
        await this.stateService.handleLoginEvent(payload ? (payload as LoginEventPayload) : undefined);
        break;
      }
      case OiamEvents.DOLOGOUT: {
        await this.stateService.handleLogoutEvent(payload ? (payload as LogoutEventPayload) : undefined);
        break;
      }
      case OiamEvents.SENDTOKEN: {
        await this.stateService.handleSendTokenEvent(payload ? (payload as SendTokenPayload) : undefined);
        break;
      }
      case OiamEvents.SENDSESSION: {
        await this.stateService.handleSendSessionEvent();
        break;
      }
      case 'oiamHasBecomeVisible': {
        await this.stateService.updateStateAfterVisibleChange();
        break;
      }
      case 'loadedFromCache': {
        await this.stateService.handleBackForwardCache();
        break;
      }
      default: {
        log.warn('oiam-oauth-wc: event not supported', name);
      }
    }
  }
}
